import React from 'react';
import './Button.style.css';

type ButtonProps = {
	borderLess?: boolean;
	chip?: boolean;
	buttonLabel: string;
} & React.ComponentPropsWithoutRef<'button'>;

const Button: React.FC<ButtonProps> = ({
	borderLess,
	chip,
	buttonLabel,
	onClick,
	className,
}) => {
	const classNames = () => {
		if (borderLess) {
			return 'no-border';
		}
		if (chip) {
			return 'chip';
		}
		return '';
	};

	return (
		<button
			type="button"
			className={`custom-button ${classNames()} ${className}`}
			onClick={onClick}
		>
			{buttonLabel}
		</button>
	);
};

export default Button;
